// Legal parameters of the Mexican AML rules (PLD/FT). Source: Ley Federal para
// la Prevención e Identificación de Operaciones con Recursos de Procedencia
// Ilícita (LFPIORPI), art. 17 fr. VI (jewelry, precious metals and watches) and
// art. 32 (cash restrictions). Every threshold is expressed in UMA (Unidad de
// Medida y Actualización) and converted with the daily UMA value that each
// company configures.

/** Identification threshold ("umbral de identificación"): 805 UMA, compared WITHOUT VAT. */
export const UMA_IDENTIFICATION = 805;
/** Notice threshold ("umbral de Aviso"): 1,605 UMA, individual or accumulated, WITHOUT VAT, any payment method. */
export const UMA_NOTICE = 1605;
/** Cash limit ("tope de efectivo", art. 32): 3,210 UMA, compared WITH VAT. */
export const UMA_CASH_LIMIT = 3210;

/** Rolling accumulation window, in months. */
export const ACCUMULATION_MONTHS = 6;

/** Fixed VAT (IVA) rate. Border-zone rates (8%) are out of scope for the MVP. */
export const VAT_RATE = 0.16;

/** Default daily UMA value (2026, INEGI). Editable per company in the settings tab. */
export const DEFAULT_UMA_VALUE = 117.31;

/** Notices (Avisos) and zero reports (Informes en cero) are due on this day of the following month. */
export const NOTICE_DEADLINE_DAY = 17;

/** A deadline this many days away (or fewer) is flagged as "due soon". */
export const DUE_SOON_DAYS = 5;

/** Deadlines and "today" are always evaluated in Mexico City time. */
export const TIME_ZONE = "America/Mexico_City";

/** Records and client files are kept at least this many years (art. 18 fr. IV LFPIORPI); nothing is purged. */
export const RETENTION_YEARS = 10;

/** Zero reports are listed at most this many months back. */
export const MAX_ZERO_REPORT_MONTHS = RETENTION_YEARS * 12;

export const ROLES = ["chamber_admin", "company_admin", "operator"] as const;

export const CLIENT_TYPES = [
  "individual",
  "foreign_individual",
  "legal_entity",
  "foreign_legal_entity",
  "trust",
] as const;

export const RISK_LEVELS = ["low", "medium", "high"] as const;

export const PAYMENT_METHODS = ["transfer", "card", "check", "cash"] as const;

export const ID_DOCUMENT_TYPES = [
  "ine",
  "passport",
  "professional_license",
  "residence_card",
  "military_card",
  "other",
] as const;

/** Files kept in a client's dossier (expediente). The checklists in dossier.ts map to these types. */
export const DOCUMENT_TYPES = [
  "id_document",
  "curp",
  "tax_certificate",
  "proof_of_address",
  "articles_of_incorporation",
  "power_of_attorney",
  "representative_id",
  "beneficial_owner_declaration",
  "beneficial_owner_id",
  "immigration_document",
  "trust_agreement",
  "trust_parties",
  "other",
] as const;

/** Accepted file formats, recognized from the file's own bytes (never from its name). */
export const DOCUMENT_CONTENT_TYPES = ["application/pdf", "image/jpeg", "image/png", "image/webp"] as const;

/** Largest client document accepted (10 MB). */
export const MAX_DOCUMENT_BYTES = 10 * 1024 * 1024;
